import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../services/api.js';
import { fmtRelativeTime } from '../utils/format.js';
import PaymentBadge from '../components/PaymentBadge.jsx';
import { statusBadgeClass } from '../utils/statusMeta.js';


export default function Claims() {
  const { itemId } = useParams();
  const [claims, setClaims] = useState(null);
  const [err, setErr] = useState(null);

  const reload = () => api.listClaims(itemId).then((r) => setClaims(r.claims)).catch((e) => setErr(e.message));
  useEffect(() => { reload(); }, [itemId]);

  async function decide(claim, decision) {
    await api.resolveClaim(itemId, claim.claimId, decision);
    reload();
  }

  if (err) return <div className="alert error">{err}</div>;
  if (!claims) return <div className="muted center loading-block">Loading…</div>;

  return (
    <div className="container-narrow page">
      <Link to={`/items/${itemId}`} className="muted tiny">← Back to item</Link>
      <h2 className="mt-12 mb-24">Finder reports</h2>

      {claims.length === 0 && (
        <div className="card center p-48">
          <p className="muted">No claims yet.</p>
        </div>
      )}

      <div className="stack">
        {claims.map((c) => <ClaimCard key={c.claimId} claim={c} onDecide={decide} />)}
      </div>
    </div>
  );
}

function ClaimCard({ claim, onDecide }) {
  const [photoUrls, setPhotoUrls] = useState([]);

  useEffect(() => {
    Promise.all((claim.photoKeys ?? []).map((k) => api.signPhotoView(k).then((r) => r.url)))
      .then(setPhotoUrls);
  }, [claim]);

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <div className="eyebrow">{fmtRelativeTime(claim.createdAt)}</div>
          <h4 className="mt-4">{claim.finderName}</h4>
        </div>
        <div className="row gap-8">
          <span className={statusBadgeClass(claim.status)}>
            {claim.status}
          </span>
          <PaymentBadge paymentRequested={claim.paymentRequested} />
        </div>
      </div>

      <dl className="kv">
        <dt className="muted tiny">Contact</dt>
        <dd>{claim.finderContact}</dd>

        {claim.foundLocation && (<><dt className="muted tiny">Location</dt><dd>{claim.foundLocation}</dd></>)}
        {claim.description && (<><dt className="muted tiny">Description</dt><dd>{claim.description}</dd></>)}
      </dl>

      {photoUrls.length > 0 && (
        <div className="photo-grid">
          {photoUrls.map((u, i) => (
            <a key={i} href={u} target="_blank" rel="noreferrer">
              <img src={u} alt={`Finder photo ${i + 1}`} />
            </a>
          ))}
        </div>
      )}

      {claim.status === 'PENDING' && (
        <div className="row mt-24">
          <button className="btn btn-primary" onClick={() => onDecide(claim, 'CONFIRMED')}>Confirm + arrange return</button>
          <button className="btn btn-danger" onClick={() => onDecide(claim, 'REJECTED')}>Reject</button>
        </div>
      )}
    </div>
  );
}
